import React from "react";
import useAuthStore from "../../stores/useAuthStore";

const StudentBasic = () => {
  const { user: student } = useAuthStore();
  const { firstname, middlename, lastname, emailaddress, level, semester, photo, studentid, matricnumber } = student || {};

  return (
    <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl p-5 text-white flex flex-col items-center text-center shadow-lg">
      {/* Avatar */}
      <div className="w-[70px] h-[70px] rounded-full p-[3px] bg-white/20 mb-3 relative">
        <img
          src={photo?.link || "../images/avatar.png"}
          alt="Student Profile"
          className="w-full h-full rounded-full object-cover border-2 border-white"
        />
        <span className="absolute bottom-0.5 right-0.5 w-3.5 h-3.5 bg-success-500 border-2 border-white rounded-full" />
      </div>

      <h3 className="text-sm font-bold uppercase m-0">
        {firstname} {middlename} {lastname}
      </h3>
      <p className="text-xs opacity-80 mt-0.5 mb-2.5">{matricnumber || studentid}</p>

      <div className="flex gap-2 flex-wrap justify-center">
        <span className="bg-white/20 px-3 py-1 rounded-full text-[0.65rem] font-bold backdrop-blur-sm">{level}</span>
        <span className="bg-white/20 px-3 py-1 rounded-full text-[0.65rem] font-bold backdrop-blur-sm">{semester}</span>
      </div>

      <p className="mt-2 text-[0.7rem] opacity-70 mb-0">{emailaddress}</p>
    </div>
  );
};

export default StudentBasic;
